/**
 * Deep-merges `loaded` into a copy of `defaults`: any key present in `defaults`
 * but absent (null/undefined) in `loaded` keeps its default value. Nested plain
 * objects are merged recursively; arrays and primitives are replaced wholesale.
 */
export function withDefaults<T extends object>(defaults: T, loaded: Partial<T>): T {
  const result = {...defaults};
  for (const key of Object.keys(result) as (keyof T)[]) {
    const loadedVal = loaded[key];
    if (loadedVal == null) continue;
    const defaultVal = defaults[key];
    if (typeof defaultVal === 'object' && !Array.isArray(defaultVal)
      && typeof loadedVal === 'object' && !Array.isArray(loadedVal)) {
      (result as Record<keyof T, unknown>)[key] =
        withDefaults(defaultVal as Record<string, unknown>, loadedVal as Record<string, unknown>);
    } else {
      result[key] = loadedVal as T[keyof T];
    }
  }
  return result;
}
